"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var WrappedPropertyArrayItem_1 = require("./WrappedPropertyArrayItem");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var WrappedPropertyArrayItemDirect_1 = require("./WrappedPropertyArrayItemDirect");
var fixData_1 = require("../JSchema/fixData");
var calcFunction_1 = require("../JSchema/calcFunction");
var aggregateFunction_1 = require("../JSchema/aggregateFunction");
var setData_1 = require("../JSchema/setData");
var defaultValue_1 = require("../JSchema/defaultValue");
var fixDateFormat_1 = require("../JSchema/fixDateFormat");
/**
 * obiekt reprezentujący tablicę danych
 *
 * @export
 * @class WrappedPropertyArray
 * @extends {WrappedPropertyBase<IArrayInternal>}
 * @implements {IWrappedProperty}
 */
var WrappedPropertyArray = /** @class */ (function (_super) {
    __extends(WrappedPropertyArray, _super);
    function WrappedPropertyArray(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        var internal = _this._internal;
        _this._internal.mparent = _this.$model;
        _this._internal.schitems = schema.items;
        // internal.subitemcache = [];
        _this._internal.cachedKey = '';
        _this._internal.cachedItems = [];
        _this._internal.mparent = _this.$model;
        _this.$schema.itemType = schema.items.type;
        functions_1.wrapSchemaProps(_this.$schema, internal, 'number', ['maxItems', 'minItems']);
        if (_this.$schema.warnings) {
            functions_1.wrapWarningProps(_this.$schema, internal, 'number', ['maxItems', 'minItems']);
        }
        // tworzenie tablicy
        var mlength = internal.mparent.length;
        _this._internal.ntable = new Array(mlength);
        if (false) {
            for (var i = 0; i < mlength; i++) {
                internal.ntable[i] = new WrappedPropertyArrayItemDirect_1.WrapperPropertyArrayItemDirect(_this, internal.mparent, i, internal.schitems, internal.options);
                // addRow(this, internal, internal.schitems, i);
            }
        }
        else {
            for (var i = 0; i < mlength; i++) {
                internal.ntable[i] = new WrappedPropertyArrayItem_1.WrapperPropertyArrayItem(_this, internal.mparent, i, internal.schitems, internal.options);
                // return ssubitem as IWrapperPropertyArrayItem;
                // addRow(this, internal, internal.schitems, i);
            }
        }
        // length
        var staticLength;
        if (schema.length !== undefined) {
            if (typeof schema.length !== 'number') {
                functions_1.wrapSchemaProp(_this.$schema, 'length', internal, function (newValue) { return _this.$setLength(newValue); });
            }
            else {
                // przeniesie ustawienia length na sam dół poniżej inicjacji Vue
                staticLength = schema.length;
            }
        }
        // console.timeEnd('addRows wrapall:' + internal.options.wrapAll + ' (' + mlength + ')');
        // computed
        var self = _this;
        internal.useComputedModel = true;
        internal.computed.items = function () {
            var smodel = parent[propName];
            if (!smodel) {
                if (internal.ntable.length) {
                    clearCached(internal);
                    internal.ntable.length = 0;
                }
                return internal.ntable;
            }
            var l = smodel.length;
            // console.log('mparent.length', mparent.length);
            if (l > internal.ntable.length) {
                // console.log('autogrow', l, ntable.length);
                while (internal.ntable.length < l) {
                    fixData_1.default(internal.schitems, smodel[internal.ntable.length], options.Vue);
                    addRow(_this, internal, internal.schitems, internal.ntable.length);
                }
            }
            else if (l < internal.ntable.length) {
                clearCached(internal);
                internal.ntable.length = l;
            }
            return internal.ntable;
            // return [];
        };
        internal.watch.items = {
            // deep,
            handler: function (newValue) {
                if (schema.debug) {
                    // tslint:disable-next-line: no-debugger
                    debugger;
                }
                if (!self.$disabled) {
                    self.$dirty = true;
                }
            }
        };
        // potrzebne przeliczenia na starcie
        if (mlength && !self._options.disableCalculations && !self._options.wrapAll) {
            var needCalc = functions_1.anyCalc(internal.schitems);
            var props = internal.schitems.properties;
            if (needCalc && props) {
                // są jakieś pola wymagające kalkulacji
                // $root,$parent,$parent2,$parent3,$external,$methods,$obj
                var paramdata = [
                    _this.$root.$model,
                    internal.mparent,
                    {},
                    {},
                    options.external,
                    options.schemaMethods,
                    ,
                    null
                ];
                if (dest) {
                    paramdata[2] = dest.$model;
                    if (dest.$parent) {
                        paramdata[3] = dest.$parent.$model;
                    }
                }
                //  let props = schitems.properties;
                for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
                    var schkey = _a[_i];
                    var schitem = props[schkey];
                    if (schitem.calc) {
                        var stime = new Date().getTime();
                        var calcFunc = calcFunction_1.default(schitem, true, process.env.NODE_ENV === 'development' && schitem.debug);
                        var $mparent = {
                            $parent: self,
                            $key: 0
                        };
                        paramdata[6] = { $key: schkey, $parent: $mparent, $parent2: self, $parent3: self.$parent };
                        try {
                            // for (let i = 0; i < mlength; i++) {
                            //  paramdata[6].$parent.$key = i;
                            for (; $mparent.$key < mlength; $mparent.$key++) {
                                var res = calcFunc.apply(internal.mparent[$mparent.$key], paramdata);
                                if (res !== undefined) {
                                    options.Vue.set(internal.mparent[$mparent.$key], schkey, res);
                                }
                                // mparent[$mparent.$key][schkey] = calcFunc.apply(mparent[$mparent.$key], paramdata);
                            }
                        }
                        catch (err) {
                            if (process.env.NODE_ENV === 'development') {
                                console.error('ERR calc:model result', err);
                                // tslint:disable-next-line: no-debugger
                                debugger;
                            }
                            // moze się wywalić wiec spokojnie
                            continue;
                        }
                        // console.log(`calc ${schkey} in ${propName}[${mlength}]`, new Date().getTime() - stime);
                    }
                    else if (schitem.aggregate) {
                        if (process.env.NODE_ENV === 'development') {
                            // tslint:disable-next-line: no-console
                            console.time('agg:model ' + self.$path + '[].' + schkey);
                            // console.info('agg:model', new Date().getTime() - stime);
                        }
                        var stime = new Date().getTime();
                        var aggFunc = aggregateFunction_1.default(schitem, true, process.env.NODE_ENV === 'development' && schitem.debug);
                        var $mparent = {
                            $parent: self,
                            $key: 0
                        };
                        paramdata[6] = { $key: schkey, $parent: $mparent, $parent2: self, $parent3: self.$parent };
                        try {
                            // for (let i = 0; i < mlength; i++) {
                            //  paramdata[6].$parent.$key = i;
                            for (; $mparent.$key < mlength; $mparent.$key++) {
                                var res = aggFunc.apply(internal.mparent[$mparent.$key], paramdata);
                                // mparent[$mparent.$key][schkey] = res;
                                if (res !== undefined) {
                                    options.Vue.set(internal.mparent[$mparent.$key], schkey, res);
                                }
                                // mparent[$mparent.$key][schkey] = calcFunc.apply(mparent[$mparent.$key], paramdata);
                            }
                            if (process.env.NODE_ENV === 'development') {
                                // tslint:disable-next-line: no-console
                                // console.timeEnd('agg:model ' + self.$path + '[].' + schkey);
                                //  console.info('agg:model', new Date().getTime() - stime);
                            }
                        }
                        catch (err) {
                            if (process.env.NODE_ENV === 'development') {
                                // tslint:disable-next-line: no-debugger
                                debugger;
                                console.warn('agg:model rerror', err);
                                // tslint:disable-next-line: no-console
                                console.timeEnd('agg:model ' + self.$path + '[].' + schkey);
                            }
                            // moze się wywalić wiec spokojnie
                            continue;
                        }
                    }
                    // if (schitems.calc) || (schitem.summary) || (schitem.agg)
                }
            }
        }
        functions_1.initVue(_this, _this._internal);
        // już po stworzeniu Vue
        if (staticLength !== undefined) {
            _this.$schema.length = staticLength;
            _this.$setLength(staticLength); // tu jest sprawdzanie disabled wiec się nie przejmuję
        }
        return _this;
    }
    /**
     * sprawdza tablicę pod kątem błedów
     *
     * @param {*} [value] wejściowa tablica
     * @returns {(string | null)} komunikat błędu lub null gdy błedu nie ma
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$validate = function (value) {
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        this.$dirty = true;
        if (value === undefined || value === null) {
            if (this.$schema.fieldRequired) {
                return functions_1.getRuleMessage(this._internal, 'required', value, this.$schema);
            }
            else {
                return null;
            }
        }
        return _super.prototype.$validate.call(this, value);
    };
    /**
     * sprawdza tablicę i wszystkie jej elementy pod kątem błędów
     *
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]} lista elementów zawierających błedy
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$validateAll = function (result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$validate() !== null) {
            result.push(this);
        }
        // this.$dirty = true;  //przeniesiono do $validate()
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$item.$validateAll(result);
        }
        return result;
    };
    /**
     * sprawdza tablicę pod kątem ostrzeżeń
     *
     * @param {*} [value] tablica
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$check = function (value, checkResult) {
        if (this._internal.schema.warnings && !this.$disabled) {
            if (value === undefined) {
                value = this.$model;
            }
            this.$dirty = true;
            checkResult = checkResult || [];
            if (value === undefined || value === null) {
                if (this.$schema.warnings.fieldRequired) {
                    checkResult.push(functions_1.getWarningMessage(this._internal, 'required', value, this.$schema));
                }
                return checkResult;
            }
            return _super.prototype.$check.call(this, value, checkResult);
        }
        return [];
    };
    /**
     * sprawdza tablicę i wszystkie jej elementy pod kątem ostrzeżeń
     *
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]} lista pól zawierających ostrzeżenia
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$checkAll = function (result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$check().length) {
            result.push(this);
        }
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$item.$checkAll(result);
        }
        return result;
    };
    /**
     * funkcja ustawania nowych danych na tablicy
     *
     * @param {*} value nowa tablica
     * @param {string} [path] ścieżka
     * @param {boolean} [fixArraySize] czy nowa dłgośc tablicy ma odpowiadać tej nowo ustawianej,
     * dla false tablica się tylko rozszerza
     * @returns {boolean} czy udało się ustawić
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$setData = function (value, path, fixArraySize) {
        // /Vue.set(parent, propName, value);
        return setData_1.default(this._internal.schema, this.$model, value, path, 0, this._options.Vue, fixArraySize);
    };
    /**
     * czyści status $dirty na wszystkich elementach tablicy
     *
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$reset = function () {
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$reset();
        }
        _super.prototype.$reset.call(this);
        // this.$dirty = false;
        // this.internal.vm.error = null;
    };
    /**
     * list elementów "dotkniętych" przez użytkownika
     *
     * @param {any[]} result
     * @returns {any[]}
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$dirtyList = function (result) {
        if (result === undefined) {
            result = [];
        }
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$dirtyList(result);
        }
        return result;
    };
    /**
     * naprawia format daty we wszytkich elementach tablicy
     *
     * @returns {number}
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$fixDateFormat = function () {
        return fixDateFormat_1.default(this._internal.schema, this.$model, this._options.Vue);
    };
    Object.defineProperty(WrappedPropertyArray.prototype, "$items", {
        /**
         * pobiera obudowane elementy tablicy
         *
         * @readonly
         * @memberof WrappedPropertyArray
         */
        get: function () {
            if (this._internal.vm) {
                return this._internal.vm.items;
            }
            else {
                return this._internal.ntable;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * ustawienie liczby wierszy w tablicy
     *
     * @param {number} newLength nowa długośc tablicy
     * @returns {boolean} czy się udało ustawić
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$setLength = function (newLength) {
        if (this.$disabled) {
            return false;
        }
        var stable = this.$model;
        if (stable.length !== newLength) {
            while (stable.length > newLength) {
                this.$removeRow(stable.length - 1);
            }
            while (stable.length < newLength) {
                // obj.$addRow(undefined, 1);
                if (!this.$addRow(undefined, newLength - stable.length)) {
                    break;
                }
            }
        }
        return stable.length === newLength;
    };
    /**
     * funkcja dodania wiersza do tablicy
     *
     * @param {*} [nvalue] wartośc dodawanego elementu, można pominąć
     * @param {number} [count=1] ilośc dodawanych wierszy
     * @returns {boolean} czy się udało daodać
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$addRow = function (nvalue, count) {
        if (count === void 0) { count = 1; }
        if (this.$disabled) {
            return false;
        }
        var mparent2 = this.$model;
        if (mparent2 === undefined) {
            // Vue.set(parent, propName, []);
            var defvalue = defaultValue_1.default(this._internal.schema, true);
            // console.log('recreate array',propName,defvalue);
            this.$setData(defvalue);
            // this.internal.Vue.set(this.internal.parent, this.propName, defvalue);
            mparent2 = this.$model;
        }
        // gdy jest ustawiona stała długość
        if (this.$schema.length !== undefined && mparent2.length === this.$schema.length) {
            return false;
        }
        this._internal.cachedKey = '';
        var startindex = mparent2.length;
        var schitems = this._internal.schitems;
        var nvalue2;
        if (schitems.type === 'object') {
            for (var i = 0; i < count; i++) {
                nvalue2 = defaultValue_1.default(schitems, true);
                if (nvalue) {
                    nvalue2 = Object.assign(nvalue2, nvalue);
                }
                mparent2.push(nvalue2);
            }
        }
        else {
            for (var i = 0; i < count; i++) {
                if (nvalue !== undefined) {
                    nvalue2 = nvalue;
                }
                else {
                    nvalue2 = defaultValue_1.default(schitems, true);
                }
                this._options.Vue.set(mparent2, startindex + i, nvalue2);
            }
        }
        for (var i = 0; i < count; i++) {
            addRow(this, this._internal, schitems, startindex + i);
        }
        return true;
    };
    WrappedPropertyArray.prototype.$removeRow = function (index) {
        if (this.$disabled) {
            return false;
        }
        var modeltable = this.$model;
        // schematable.splice(index, 1);
        if (this.$schema.length !== undefined && modeltable.length === this.$schema.length) {
            return false;
        }
        index = index || this._internal.ntable.length - 1;
        if (index < 0 || index >= this._internal.ntable.length) {
            return false;
        }
        this._internal.cachedKey = '';
        var removed = this._internal.ntable.splice(index, 1);
        var l = this._internal.ntable.length;
        for (var i = index; i < l; i++) {
            this._internal.ntable[i].$setKey(i);
        }
        // usunąc cache
        removed[0].$clearCache();
        modeltable.splice(index, 1); // bo na tym jest event ?
        return true;
    };
    WrappedPropertyArray.prototype.$clearRow = function (index) {
        if (this.$disabled) {
            return false;
        }
        var nitem = defaultValue_1.default(this._internal.schema);
        this._internal.ntable[index].$clearCache();
        this._options.Vue.set(this.$model, index, nitem);
        return true;
    };
    /**
     * przesunięcie wierszy
     *
     * @param {number} index1 pierwszy indeks w tabeli
     * @param {number} index2 drugi indeks w tabeli
     * @returns {boolean} czy się udało zamienić
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$exchangeRow = function (index1, index2) {
        if (this.$disabled) {
            return false;
        }
        this._internal.cachedKey = '';
        var mparent = this.$model;
        var item1 = mparent[index1];
        var item2 = mparent[index2];
        this._internal.ntable[index1].$clearCache();
        this._internal.ntable[index2].$clearCache();
        this._options.Vue.set(mparent, index1, item2);
        this._options.Vue.set(mparent, index2, item1);
        return true;
    };
    /**
     * przesunięcie wiersza do góry
     *
     * @param {number} index index wiersza, musi być większy od 0
     * @returns {boolean} czy się udało przesunąć
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$moveUp = function (index) {
        if (this.$disabled) {
            return false;
        }
        if (index > 0) {
            return this.$exchangeRow(index, index - 1);
        }
        return false;
    };
    /**
     * przesunięcie wiersza w dół
     *
     * @param {number} index indeks wiersza w tabeli, nie może to być ostatni wiersz
     * @returns {boolean} czy się udało
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$moveDown = function (index) {
        if (this.$disabled) {
            return false;
        }
        if (index < this.$model.length - 1) {
            return this.$exchangeRow(index, index + 1);
        }
        return false;
    };
    /**
     * sortowanie tablicy
     *
     * @param {string} field po jakim polu posortować
     * @returns
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$sort = function (field) {
        if (this.$disabled) {
            return;
        }
        // let stime = new Date().getTime();
        this._internal.cachedKey = '';
        var mparent = (this._internal.mparent = this._internal.mparent.sort(function (a, b) {
            return b[field] === a[field] ? 0 : b[field] > a[field] ? -1 : 1;
        }));
        // mparent = parent[propName] = narray;
        // destroy
        // clearCached();
        var index = this._internal.ntable.length;
        while (index--) {
            this._internal.ntable[index].$clearCache();
        }
        // tslint:disable-next-line: max-line-length
        // console.log('sorting', propName, field, new Date().getTime() - stime, mparent[0][field], mparent[mparent.length - 1][field]);
    };
    /**
     * zwraca częśc tablicy wg filtra
     *
     * @param {(value: any, index: number, array: any[]) => boolean} func filtr
     * @returns {any[]} filtrowana tablica
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$filter = function (func) {
        if (func) {
            return this._internal.ntable.filter(func);
        }
        return this._internal.ntable;
    };
    Object.defineProperty(WrappedPropertyArray.prototype, "pageNumber", {
        /**
         * aktualny numer strony
         *
         * @type {number}
         * @memberof WrappedPropertyArray
         */
        get: function () {
            return this.$getUserData('pageNumber', 0);
            // return this.$data.pageNumber || 0;
        },
        /**
         * ustawienie numeru strony
         *
         * @memberof WrappedPropertyArray
         */
        set: function (newValue) {
            if (newValue < 0) {
                this.$setUserData('pageNumber', 0);
                // this._options.Vue.set(this.$data, 'pageNumber', 0);
            }
            else if (newValue >= this.pageCount) {
                if (process.env.NODE_ENV === 'development') {
                    console.warn('overflow pagenumber', newValue, this.pageCount - 1);
                }
                this.$setUserData('pageNumber', this.pageCount - 1);
                // this._options.Vue.set(this.obj.$data, 'pageNumber', this.pageCount - 1);
            }
            else {
                this.$setUserData('pageNumber', newValue);
                // this._options.Vue.set(this.obj.$data, 'pageNumber', newValue);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyArray.prototype, "pageSize", {
        /**
         * aktualny rozamir strony
         *
         * @type {number}
         * @memberof WrappedPropertyArray
         */
        get: function () {
            return this.$getUserData('pageSize', 25);
            // return this.$data.pageSize;
        },
        /**
         * ustawienie rozmiaru strony
         *
         * @memberof WrappedPropertyArray
         */
        set: function (newValue) {
            this.$setUserData('pageSize', newValue);
            // this._options.Vue.set(this.$data, 'pageSize', newValue);
            if (this.pageNumber >= this.pageCount) {
                this.pageNumber = this.pageCount - 1;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyArray.prototype, "pageCount", {
        /**
         * ilośc stron
         *
         * @readonly
         * @type {number}
         * @memberof WrappedPropertyArray
         */
        get: function () {
            if (this.$schema.$disabled) {
                return 0;
            }
            return Math.ceil(this.$model.length / this.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyArray.prototype, "order", {
        /**
         * sposób sortowania tablizy zwracanej przez $getItems
         *
         * @type {string}
         * @memberof WrappedPropertyArray
         */
        get: function () {
            return this.$getUserData('order', '');
        },
        /**
         * sposób sortowania tablizy zwracanej przez $getItems
         *
         * @memberof WrappedPropertyArray
         */
        set: function (newValue) {
            this.$setUserData('order', newValue);
            // this._options.Vue.set(this.$data, 'order', newValue);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * pobranie częsciowej tablicy
     *
     * @param {number} [start] indeks startowy elementu
     * @param {number} [count] ile elementów
     * @returns
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$getItems = function (start, count) {
        // console.log('dssdfsdfs');
        var mparent2 = this.$model;
        start = start || 0;
        if (count && this.pageSize !== count) {
            // console.log('set pageSize', count);
            this.pageSize = count;
        }
        var end = count;
        if (end === undefined) {
            end = mparent2.length;
        }
        else {
            end += start;
            if (end >= mparent2.length) {
                end = mparent2.length;
            }
        }
        var stime = new Date().getTime();
        var res = [];
        if (true /*usesubitem*/) {
            // const order = this.order;
            var order_1 = this.$getUserData('order', '');
            var nkey = start + "|" + end + "|" + order_1;
            if (nkey === this._internal.cachedKey) {
                // console.log('return cached data', new Date().getTime() - stime);
                return this._internal.cachedItems;
            }
            if (order_1) {
                // let stime = new Date().getTime();
                var otable = Array.from(this._internal.ntable);
                otable.sort(function (a, b) {
                    return mparent2[b.$key][order_1] === mparent2[a.$key][order_1]
                        ? 0
                        : mparent2[b.$key][order_1] > mparent2[a.$key][order_1]
                            ? -1
                            : 1;
                });
                // console.log('order by', (new Date()).getTime() - stime, order, otable[0].$item, ntable[0].$item);
                // tslint:disable-next-line: max-line-length
                // let narray = parent[propName].sort((a: any, b: any) => (b[field] === a[field]) ? 0 : (b[field] > a[field]) ? -1 : 1);
                for (var i = start; i < end; i++) {
                    res.push(otable[i].$item);
                }
                // console.log('return ordered data', new Date().getTime() - stime);
            }
            else {
                // console.log('not ordered', ntable[0].$item);
                for (var i = start; i < end; i++) {
                    res.push(this._internal.ntable[i].$item);
                }
            }
            this._internal.cachedItems = res;
            this._internal.cachedKey = nkey;
            // const aa: any[] = this.$items as WrappedProperty[];
            // console.log("$getItems",start,end,res.length,aa.length);
            // console.log("$getItems", propName, start, end, res.length, (new Date()).getTime() - stime);
            // return res;
            // res = reactivedata.items.slice(start, end).map((x: any) => x.$item);
        }
        else {
            // res = reactivedata.items.slice(start, end);
        }
        // console.log('$getItems.slide', (new Date()).getTime() - stime, res);
        return res;
        // return
    };
    /**
     * pobranie strony
     *
     * @param {number} page numer strony
     * @param {number} [pageSize=25] rozamiar strony
     * @returns
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$getPage = function (page, pageSize) {
        if (pageSize === void 0) { pageSize = 25; }
        // console.log('get page');
        return this.$getItems(page * pageSize, pageSize);
    };
    /**
     * wyczyszenie cache elementów tablicy
     *
     * @memberof WrappedPropertyArray
     */
    WrappedPropertyArray.prototype.$destroy = function () {
        clearCached(this._internal);
        _super.prototype.$destroy.call(this);
    };
    /**
     * zdarzenie przed zmianą ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyArray.prototype.beforePathChange = function () {
        _super.prototype.beforePathChange.call(this);
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].beforePathChange();
        }
    };
    /**
     * zdarzenie po zmianie ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyArray.prototype.afterPathChange = function () {
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].afterPathChange();
        }
        _super.prototype.afterPathChange.call(this);
    };
    return WrappedPropertyArray;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyArray;
/**
 * dodanie wiersza do tablicy
 *
 * @param {WrappedPropertyArray} self obiekt repezentujący tablicę
 * @param {IArrayInternal} internal dane wewnętrzne obiektu
 * @param {*} schitems schemat pola
 * @param {number} rowIndex indeks dodwanago wiersza
 * @returns {IWrapperPropertyArrayItem} obudowany element tablicy
 */
function addRow(self, internal, schitems, rowIndex) {
    var ssubitem = new WrappedPropertyArrayItem_1.WrapperPropertyArrayItem(self, internal.mparent, rowIndex, schitems, internal.options);
    internal.ntable.push(ssubitem);
    return ssubitem;
}
/**
 * usunięcie cache wszystkich elementów tablicy
 *
 * @param {IArrayInternal} internal
 */
function clearCached(internal) {
    // tslint:disable-next-line: prefer-for-of
    for (var i = 0; i < internal.ntable.length; i++) {
        internal.ntable[i].$clearCache();
    }
}
WrappedPropertyCtor_1.default.array = WrappedPropertyArray;
//# sourceMappingURL=WrappedPropertyArray.js.map